// TYPES
import { ShareholderData } from "../../types";

// COMPONENTS
import { Icon } from "@allaria-tech/matter/Icon";
import { IconButton } from "@allaria-tech/matter/IconButton";
import { Typography } from "@allaria-tech/matter/Typography";

import styles from "./Shareholders.module.scss";

interface ShareHolderProps {
  shareholder: ShareholderData;
  index: number;
  isActive: boolean;
  isUncompleted?: boolean;
  showEditAction?: boolean;
  onClick: () => void;
}

const Shareholder = ({
  shareholder,
  index,
  isActive,
  isUncompleted,
  showEditAction,
  onClick,
}: ShareHolderProps) => {
  const {
    shareholderCard,
    active,
    uncompleted,
    shareholderContent,
    shareholderHeader,
    shareholderName,
    shareholderDetail,
    detailSeparator,
    shareholderEdit,
  } = styles;

  const isPhysicalPerson = shareholder?.personType === "PHYSICAL";

  const name = isPhysicalPerson
    ? [shareholder.name, shareholder.lastName].filter(Boolean).join(" ")
    : shareholder?.legalName;

  const ownership = shareholder?.ownership;

  return (
    <div
      id={`shareholder-${index}`}
      className={`${shareholderCard} ${isActive ? active : ""} ${
        isUncompleted ? uncompleted : ""
      }`}
      onClick={onClick}
    >
      <div className={shareholderContent}>
        <div className={shareholderHeader}>
          {isUncompleted && (
            <Icon
              name="warning-filled"
              size="sm"
              color="var(--icon-feedback-warning, #dea916)"
              label={`Accionista ${index} incompleto`}
            />
          )}
          <Icon name={isPhysicalPerson ? "user-2" : "company"} size="sm" />
          <Typography
            className={shareholderName}
            type="HEADING"
            size="S"
            weight="EMPHASIS"
          >
            {name}
          </Typography>
        </div>
        <div className={shareholderDetail}>
          <Typography type="BODY" size="S">
            Accionista {index}
          </Typography>
          {!!ownership && (
            <>
              <span className={detailSeparator} />
              <Typography type="BODY" size="S">
                {ownership}%
              </Typography>
            </>
          )}
        </div>
      </div>
      {showEditAction && (
        <IconButton
          className={shareholderEdit}
          variant="outline"
          size="small"
          aria-label={`Editar accionista ${index}`}
          icon={<Icon name="edit" size="sm" />}
          onClick={onClick}
        />
      )}
    </div>
  );
};

export default Shareholder;
